export const LOGIN_MODES = {
    1: '帐号密码登录',
    2: '短信验证码登录',
    3: '扫码登录'
};
export const LANGUAGE_NAMES = {
    'zh-CN': '中文',
    en: '英文'
};

export const INTERNATIONAL_MODES = {
    China: '中国站',
    International: '国际站'
};
